<template>
  <div class="footer">
    <div class="route-wrap">
      <template v-for="route in constantRoutes">
        <div v-if="!route.hidden" :key="route.name">
          <h3>
            <router-link :to="{ name: route.name }">
              {{ route.meta.title }}
            </router-link>
          </h3>
          <template v-for="route in route.children">
            <span v-if="!route.hidden" :key="route.name">
              <router-link :to="{ name: route.name }">
                {{ route.meta.title }}
              </router-link>
            </span>
          </template>
        </div>
      </template>

      <div v-if="platform.qrcode">
        <img
          class="w-32 h-32 bg-gray-100 rounded"
          :src="platform.qrcode"
          alt="交易小程序"
        />
        <p class="text-white mt-2">扫码进入小程序</p>
      </div>
    </div>
    <div
      class="text-center text-white text-sm py-4 border-t border-white border-opacity-50"
    >
      <div class="flex items-center justify-center mb-5">
        <p>友情链接：</p>
        <a
          class="hover:text-primary"
          href="https://www.zyctd.com/"
          target="_blank"
          >中药材天地网</a
        >
        <i class="w-px h-3 bg-white mx-3"></i>
        <a
          class="hover:text-primary"
          href="https://www.yt1998.com/"
          target="_blank"
          >药通网</a
        >
        <i class="w-px h-3 bg-white mx-3"></i>
        <a
          class="hover:text-primary"
          href="https://tcmcloud.bucm.edu.cn/tcmexpress/"
          target="_blank"
          >中医药云体验</a
        >
        <i class="w-px h-3 bg-white mx-3"></i>
        <a
          class="hover:text-primary"
          href="https://www.mfhcn.com/"
          target="_blank"
          >药食同源数据库</a
        >
        <i class="w-px h-3 bg-white mx-3"></i>
        <a
          class="hover:text-primary"
          href="http://lcxzyc.lczf.gov.cn:9090/city/"
          target="_blank"
          >陵川县中药材产销对接大数据平台</a
        >
      </div>
      <p>
        <span>{{ platform.main_office }}</span>
        <span class="ml-4">{{ platform.tech_office }}</span>
      </p>
      <p>
        <a
          class="hover:text-primary"
          target="_blank"
          href="https://beian.miit.gov.cn/"
        >
          {{ platform.recorde_num }}
        </a>
        <span class="ml-2">{{ platform.copyright_office }}</span>
      </p>
    </div>
  </div>
</template>

<script>
import { constantRoutes } from "@/router/index";
import { mapState } from "vuex";

export default {
  data() {
    return {
      constantRoutes: Object.freeze(constantRoutes),
    };
  },
  computed: {
    ...mapState("app", ["platform"]),
  },
};
</script>

<style scoped lang="scss">
.footer {
  /* height: 278px; */
  background: rgba(31, 45, 36, 1);
  .route-wrap {
    width: 1000px;
    margin: 0 auto;
    padding-bottom: 16px;
    min-height: 200px;
    display: flex;
    justify-content: space-evenly;
    align-items: flex-start;
    padding-top: 26px;
    > div {
      display: flex;
      flex-flow: column;
      align-items: center;
      h3 {
        font-size: 18px;
        font-weight: bold;
        color: #ffffff;
        margin-bottom: 15px;
      }
      span {
        font-size: 14px;
        font-weight: 400;
        color: #ffffff;
        line-height: 30px;
        opacity: 0.7;

        &:hover {
          opacity: 1;
        }
      }
    }
    > p {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 68px;
      text-align: center;
      font-size: 14px;
      color: #ffffff;
      line-height: 23px;
      border-top: 1px solid rgba(151, 151, 151, 0.3);
    }
  }
}
</style>
